import { useMemo } from "react";
import { useGetMyGroups, useCheckUserLnqRights } from "../../api/GroupApi";
import { useUserData } from "../../api/UserApi";

export const useGroupsWithLnqRights = () => {
  const { data: myGroupsData } = useGetMyGroups(1, 0);
  const { data: lnqRightsData } = useCheckUserLnqRights();
  const { data: currentUser } = useUserData();

  const groupsWithLnqRights = useMemo(() => {
    if (!myGroupsData?.docs || !currentUser) return [];
    return myGroupsData.docs.filter((group) => {
      const hasApiRight = lnqRightsData?.groups?.some((g) => g.groupId === group.id);
      const isAdmin = group.groupProviders?.some(
        (provider) => provider.user?.id === currentUser.id && provider.role === "admin",
      );
      return hasApiRight ?? isAdmin;
    });
  }, [myGroupsData?.docs, lnqRightsData?.groups, currentUser]);

  return {
    groups: groupsWithLnqRights,
    isLoading: !myGroupsData || !lnqRightsData || !currentUser,
  };
};
